<template lang="pug">
    #app.app-sidebar-fixed(v-if="isLoggedIn", :class="{'dark-mode': isDarkMode}")
      // sidebar
      sidebar-view
      // / sidebar
      .app-content
        // start: TOP NAVBAR
        header-view
        // end: TOP NAVBAR
        router-view
      // start: FOOTER
      footer-view
      // end: FOOTER
    div#container-without-sidebar(v-else-if="loginCheckCompleted")
      router-view
</template>

<script>
import url from './assets/css/styles.css';
import './assets/css/plugins.css';
import './assets/css/vanilla-float-labels.css';
import './assets/css/themes/theme-3.css';

import Vue from 'vue';
import { mapState } from 'vuex';
import VueCookie from 'vue-cookie';
import VueTheMask from 'vue-the-mask';

import Sidebar from '@/components/Sidebar';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Page from '@/components/core/Page';
import store from '@/store/index';

Vue.use(VueCookie);
Vue.use(VueTheMask);

Vue.component('page', Page);
Vue.component('field', () => import('@/components/core/Field'));
Vue.component('ComboBox', () => import('@/lib/fields/CheckBox'));

export default {
    store,
    created() {
        this.$store.dispatch('loginCheck');
        this.$store.dispatch('getExperiments');
    },
    /* mounted() {
        (function(d, w, c) {
            w.ChatraID = 'bMSKiSEtAk6Xo7cyE';
            var s = d.createElement('script');
            w[c] = w[c] || function() {
                (w[c].q = w[c].q || []).push(arguments);
            };
            s.async = true;
            s.src = 'https://call.chatra.io/chatra.js';
            if (d.head) d.head.appendChild(s);
        })(document, window, 'Chatra');
    }, */
    updated() {
        if (this.canInitializeTheme) {
            this.canInitializeTheme = false;
            initializeTheme();
        }
    },
    name: 'app',
    components: {
        'header-view': Header,
        'sidebar-view': Sidebar,
        'footer-view': Footer
    },
    watch: {
        isLoggedIn(val) {
            this.canInitializeTheme = true;
        }
    },
    computed: mapState({
        loginCheckCompleted: state => state.authentication.loginCheckCompleted,
        isLoggedIn: state => state.authentication.isLoggedIn,
        isDarkMode: state => state.localStorage.isDarkMode
    })
};
</script>



// WEBPACK FOOTER //
// src/App.vue